import { schema } from 'normalizr';
import merge from 'lodash/merge';
import { mapLocalizable } from '../common/utils';
import { LocalizableString, BoothContentElement } from '../common/types';

export type BoothTab = {
  id: string;
  boothId: string;
  title: LocalizableString;
  body: BoothContentElement[];
  masterElement: {
    masterControlledBody: boolean;
  };
  $fetching: false;
}

export const isContentElementPresentInLocale = ({ __typename: typeName, ...content }, locale): boolean => {
  switch (typeName) {
    case 'BoothRichtextContentElement': {
      const values = content?.contentRichtextHtml;
      return !!values?.[locale]?.value;
    }
    case 'BoothQuestionContentElement': {
      const values = content?.question;
      return (
        !!values?.[locale]
        && !!content?.answer
        && isContentElementPresentInLocale(content?.answer, locale)
      );
    }
    case 'BoothImageContentElement': {
      const values = content?.image;
      return !!values?.[locale]?.value?.originalImageUrl;
    }
    case 'BoothVideoContentElement': {
      const values = content?.videoFile;
      return !!values?.[locale]?.value?.playbackUrl;
    }
    case 'BoothFileContentElement': {
      const values = content?.file;
      return !!values?.[locale]?.value?.fileUrl;
    }
    default: {
      return false;
    }
  }
};

export const boothTabEntity = new schema.Entity('boothTabs', {}, {
  mergeStrategy(first, second) {
    return merge(first, mapLocalizable(second));
  },
  processStrategy(entity) {
    return mapLocalizable(entity);
  },
});
